import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/fashionunited-news.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import HomeLink from '../components/HomeLink';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import Markdown from '../components/Markdown';

const FashionUnitedNewsPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="fashionunited-news"
      passHref
    >
      {intl.formatMessage(messages['fashionUnitedNews.title'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['fashionUnitedNews.title'])}
        description={intl.formatMessage(messages['fashionUnitedNews.title'])}
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages['fashionUnitedNews.title'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

FashionUnitedNewsPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default FashionUnitedNewsPage;
